import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ToolTipList = ({ items }) => {
  if (!items?.length) return null

  return (
    <Styles.TooltipListContainer>
      {items?.map((item, index) => (
        <li key={index}>
          <Text type="bodySRegular">{item}</Text>
        </li>
      ))}
    </Styles.TooltipListContainer>
  )
}

export default ToolTipList
